interface AgentOverlayEntryCopy {
  label: string;
  openAccessibleLabel: string;
  upsellAccessibleLabel: string;
  upsellTitle: string;
}

export const AGENT_INTENT_MODEL_V2_FEATURE_FLAG = "mem-agent-intent-model-v2";

export const resolveAgentOverlayEntryCopy = (supportsGoals: boolean): AgentOverlayEntryCopy => {
  if (supportsGoals) {
    return {
      label: "Tasks, projects & goals",
      openAccessibleLabel: "Open tasks, projects, and goals",
      upsellAccessibleLabel: "Try Proactive for tasks, projects, and goals",
      upsellTitle: "Upgrade for task, project & goal tracking",
    };
  }

  return {
    label: "Tasks & projects",
    openAccessibleLabel: "Open tasks and projects",
    upsellAccessibleLabel: "Try Proactive for tasks and projects",
    upsellTitle: "Upgrade for task & project tracking",
  };
};
